export const TARGET_HANDLE_ID = 'in';
export const DEFAULT_SOURCE_HANDLE_ID = 'out';

export const buildSourceHandleId = (branchID) =>
    branchID ? `branch:${branchID}` : DEFAULT_SOURCE_HANDLE_ID;

export const parseSourceHandleId = (handleId) => {
    if (!handleId || handleId === DEFAULT_SOURCE_HANDLE_ID) return { branchID: null };
    if (handleId.startsWith('branch:')) return { branchID: handleId.slice(7) };
    return { branchID: null };
};
